module.exports = __webpack_public_path__ + "img/cool_system_sicom_step1.0abc4b5c.jpg";